module.exports = __webpack_public_path__ + "img/search.7557abfa.png";